import { Command } from 'commands/Commands';

export class ChangeAddressVisibility  extends Command {
  type: string = 'ChangeAddressVisibility';
  priority: number = 100;
}
